module.exports = __webpack_public_path__ + "static/Statistics-scot.d80d9389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Statistics-scot.jpg
// module id = 510
// module chunks = 153228935106781